export default __webpack_public_path__ + "static/media/PTS7.11fbbeff.jpg";